import {ActionType} from 'constants/flow/flowTypes';
import {CHECKOUT} from 'constants/actions';
import {AxiosResponse} from 'axios';

import {OrderReviewType} from './orderReviewType';

export const initialState: OrderReviewType = {
    status: '',
    items: {
        is_hto: false,
        items: [],
    },
};

/**
 * Order review items
 * @param {OrderReviewType} state Current state
 * @param {ActionType<OrderReviewType>} action Received action
 * @returns {OrderReviewType} Order review data
 */
export default function orderReview(
    state: OrderReviewType = initialState,
    action: ActionType<AxiosResponse>,
): OrderReviewType {
    switch (action.type) {
        case `${CHECKOUT.GET_ORDER_REVIEW_ITEMS}_PENDING`:
            return {...state, status: 'pending'};
        case `${CHECKOUT.GET_ORDER_REVIEW_ITEMS}_FULFILLED`:
            return {
                status: 'fulfilled',
                items: {
                    items: action.payload.data,
                    is_hto: action.payload.data
                        .filter(item => item.active)
                        .every(item => item.productAsHTO),
                },
            };
        default:
            return state;
    }
}
